
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exchange",
      function () {
        return require("private-next-pages/exchange.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exchange"])
      });
    }
  